import { REDUCER_KEY_AUTH } from "./auth.reducer";
export var getUser = function (state) { return state.auth.user; };
export var updateUserById = function (id, state) {
    return state.auth.updateUserById[id];
};
export var hasAccessToken = function (state) { var _a; return ((_a = state.auth) === null || _a === void 0 ? void 0 : _a.hasAccessToken) || false; };
export var getSelectedDashboardType = function (state) {
    return state[REDUCER_KEY_AUTH].selectedDashboardType;
};
export var isRemovingProfile = function (state) {
    return state.auth.isRemovingProfile;
};
export var removeProfileError = function (state) {
    return state.auth.removeProfileError;
};
